import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getPositionDevices: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.POSITION_DEVICES].GET_POSITION_DEVICES,
	},
	getPositionDevice: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.POSITION_DEVICES].GET_POSITION_DEVICE,
	},
}